import { FiChevronLeft } from "react-icons/fi";
import "./MobileBackButton.css";

export default function MobileBackButton({ className = "", ...props }) {
  return (
    <button
      type="button"
      aria-label="Back"
      {...props}
      className={`mobile-back-button ${className}`.trim()}
    >
      <FiChevronLeft aria-hidden="true" />
    </button>
  );
}
